// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage"
import { connectFunctionsEmulator, getFunctions } from "firebase/functions"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCevn2t1DbcpBpkQWqHOxYNh3esakjyaSo",
  authDomain: "managers-testing.firebaseapp.com",
  projectId: "managers-testing",
  storageBucket: "managers-testing.appspot.com",
  messagingSenderId: "808662951760",
  appId: "1:808662951760:web:48d3ca9fe568ab1d9e6e55",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

//init firestore
const db = getFirestore()

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app)

//init firebase auth
const auth = getAuth()

//firebase functions
const functions = getFunctions(app)

// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "localhost", 5001)
// }

//current user
const currentUser = auth.currentUser

export { db, auth, currentUser, storage, functions }
